<template>
  <div id="model_view" v-loading.fullscreen.lock="loading">
    <div class="resizable-layout">
      <div class="record-list-section" :style="{ width: recordListWidthPercent + '%' }">
        <RecordList :model="model" />
      </div>

      <!-- Draggable Resize Handle -->
      <div class="resize-handle" @mousedown="startResize" :class="{ 'resizing': isResizing }">
        <div class="resize-line"></div>
      </div>

      <div class="details-section" :style="{ width: detailsWidthPercent + '%' }">
        <div class="details_style">
          <Contextbar />
          <RecordChecks />
          <ModelDetails :model="model" type="D" />
        </div>
      </div>
    </div>
    <DialogWindow />
  </div>
</template>


<script>
import Contextbar from "../components/Contextbar.vue";
import DialogWindow from '../components/DialogWindow';
import ModelDetails from "../components/ModelDetails.vue";
import RecordChecks from "../components/RecordChecks.vue";
import RecordList from "../components/RecordList.vue";
// import { ElMessage } from 'element-plus'
import { computed, inject, onMounted, onUnmounted, provide, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { apiHelpers } from "../helpers";
import { messages } from '../popups.js';
import { uiHelpers } from "../ui_helpers";
// import { strictEqual } from "assert";
export default {
  name: "Models",
  components: {
    RecordList,
    Contextbar,
    ModelDetails,
    RecordChecks,
    DialogWindow
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const model = route.params.model;
    const { getrecorddetails, getrecordhistory, store } = apiHelpers(model);
    const { showerorr, notify } = messages()
    const { getmodelmetadata } = uiHelpers(model);
    const { ws_send } = inject('ws_connection')
    const loading = ref(false)
    const recordListWidth = ref(6) // Default width (6/24 columns)
    const isResizing = ref(false)

    // Computed property for details column width
    const detailsWidth = computed(() => {
      return 24 - recordListWidth.value
    })

    // Computed properties for percentage widths
    const recordListWidthPercent = computed(() => {
      return (recordListWidth.value / 24) * 100
    })

    const detailsWidthPercent = computed(() => {
      return (detailsWidth.value / 24) * 100
    })

    // Drag resize functionality
    const startResize = (e) => {
      isResizing.value = true
      const startX = e.clientX
      const startWidth = recordListWidth.value
      const containerWidth = e.target.closest('.resizable-layout').offsetWidth

      const handleMouseMove = (e) => {
        if (!isResizing.value) return

        const deltaX = e.clientX - startX
        const deltaPercent = (deltaX / containerWidth) * 24 // Convert to 24-column grid
        let newWidth = Math.round(startWidth + deltaPercent)

        // Constrain width between 3 and 15 columns
        newWidth = Math.max(3, Math.min(15, newWidth))
        recordListWidth.value = newWidth
      }

      const handleMouseUp = () => {
        isResizing.value = false
        document.removeEventListener('mousemove', handleMouseMove)
        document.removeEventListener('mouseup', handleMouseUp)
        document.body.style.cursor = ''
        document.body.style.userSelect = ''
      }

      document.addEventListener('mousemove', handleMouseMove)
      document.addEventListener('mouseup', handleMouseUp)
      document.body.style.cursor = 'col-resize'
      document.body.style.userSelect = 'none'

      e.preventDefault()
    }

    onMounted(async () => {
      // store.commit("api/status", "");
      await getmodelmetadata(route.params.key);
      // if (store.state.ui.is_singleton == true) {
      //   router.push({to: '/s/' + model})
      // }
    });
    onUnmounted(async () => {
      store.commit("api/reset");
      store.commit("ui/reset");
    });

    const keys = computed(() => {
      return Array.from(
        store.state.api.keys,
        (x) => store.state.api.record_details[x]
      ).join("~");
    });

    const heading = computed(() => {
      return store.state.api.status > ""
        ? route.params.model +
        ": " +
        keys.value +
        "(" +
        store.state.api.status +
        ")"
        : route.params.model + ": " + keys.value;
    });

    const prev_record = async () => {
      store
        .dispatch("api/get_next_prev", { method: "prev" })


    };
    const next_record = async () => {
      store
        .dispatch("api/get_next_prev", { method: "next" })
    };

    const prev_or_next = async () => {
      store
        .dispatch("api/get_next_prev", { method: "prev_or_next" })
    };

    const new_record = async () => {
      await router.push({ params: { key: null } });
      store.commit("api/newRecord");
    };
    const cancel_new_record = async () => {
      await router.push({ params: { key: null } });
      store.commit("api/noRecord");
    };

    const delete_record = () => {
      store
        .dispatch("api/delete", {
          model: model,
        })
        .then(() => {
          notify('success', "Deleted")
          prev_or_next();
        })
        .catch((err) => {
          showerorr(err);
        });
    };
    const save_record = () => {
      store
        .dispatch("api/post_put", {
          model: model,
          key: keys.value
        })
        .then(() => {
          ws_send("jeee")
          notify('success', "Saved");
        })
        .catch((err) => {
          showerorr(err);
        });
    };
    const cancelChanges = async () => {
      if (store.state.api.status == "M") {
        await getrecorddetails(keys.value);
      } else {
        cancel_new_record();
      }
    };

    const show_history = async () => {
      await getrecordhistory(keys.value);
    };

    let dialogvisible = inject('dialogvisible')
    let current_dialog_view = inject('current_dialog_view')
    let dialog_params = ref({})
    const backend_method = (params) => {
      if (params.dialog !== 'undefined' && params.dialog > '') {
        dialog_params.value = params

        current_dialog_view.value = params.dialog
        dialogvisible.value = true
        return
      }
      loading.value = true
      store
        .dispatch("api/backend_method", params)
        .then(() => {
          notify('success', "Success");
          loading.value = false
        })
        .catch((err) => {
          showerorr(err);
          loading.value = false
        });
    };

    const runFunction = (method, params) => {
      if (method == "new_record") new_record()
      if (method == "delete_record") delete_record()
      if (method == "save_record") save_record()
      if (method == "cancelChanges") cancelChanges()
      if (method == "prev_record") prev_record()
      if (method == "next_record") next_record()
      if (method == "show_history") show_history()
      if (method == "backend_method") backend_method(params)

    };

    watch(
      () => route.params.key,
      async (newkey) => {
        await getrecorddetails(newkey);
      }
    );
    provide("runFunction", runFunction)
    provide("dialog_params", dialog_params)
    return {
      heading,
      keys,
      route,
      model,
      loading,
      recordListWidth,
      detailsWidth,
      recordListWidthPercent,
      detailsWidthPercent,
      isResizing,
      startResize
    };
  },
};
</script>


<style scoped>
#content {
  margin: 0 !important;
}

.el-row {
  margin-bottom: 0px !important;
}

.resizable-layout {
  display: flex;
  height: 100vh;
  position: relative;
}

.record-list-section {
  position: relative;
  overflow: hidden;
}

.details-section {
  position: relative;
  overflow: hidden;
}

.details_style {
  height: 100%;
  border-left: 1px solid rgb(146, 149, 161);
}

.resize-handle {
  width: 4px;
  height: 100%;
  cursor: col-resize;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;
  flex-shrink: 0;
}

.resize-handle:hover {
  background-color: rgba(64, 158, 255, 0.1);
}

.resize-handle.resizing {
  background-color: rgba(64, 158, 255, 0.2);
}

.resize-line {
  width: 1px;
  height: 100%;
  background-color: rgb(146, 149, 161);
  transition: all 0.2s ease;
}

.resize-handle:hover .resize-line,
.resize-handle.resizing .resize-line {
  background-color: #409eff;
  width: 3px;
}

/* Mobile responsive */
@media (max-width: 768px) {
  .resizable-layout {
    flex-direction: column;
  }

  .record-list-section,
  .details-section {
    width: 100% !important;
    height: 50%;
  }

  .resize-handle {
    display: none;
  }

  .details_style {
    border-left: none;
    border-top: 2px solid rgb(146, 149, 161);
    padding-left: 0;
    /* padding-top: 10px; */
  }
}
</style>
